import React from "react";
import { AdminProductsPageTemplate } from "../../components/templates";
const AdminDashboardPage = () => {
  return <AdminProductsPageTemplate />;
};
export { AdminDashboardPage };
